import React, { useState } from "react";

const LeadCondition = (props) => {
    const data = props;
    
    const onBlur = (index) => {
        return (e) => {
           const tempErr = (data.errors).map((er,i)=>{
                if(index === i){
                    if(!(e.target.value).length){
                        er.message = 'Please Enter a valid value';
                    }
                }
                return er;
            });
            data.setErrors(tempErr);
        }
    }
    const onFocus = (index) => {
        return (e) => {
            const tempErr = (data.errors).map((er,i)=>{
                if(index === i){
                    er.message = '';
                }
                return er;
            });
            data.setErrors(tempErr);
        }
    }

    return(<>
    <div className="column-2-outer">
        {data.index !== 0 && <div className="condition-clause"><span onClick={()=>{data.handleClauseChange()}}>{data.clause}</span></div>}
        <div className="column-2-inner">
            <div className="field-wrap">
                <label className="label-xs">Recipient</label>
                <select 
                    name="type" 
                    className="selectbox" 
                    value={data.condition.type}
                    onChange={data.handleLeadsFieldChange(data.index)}>
                        <option value={'reply'}>Replies</option>
                        <option value={'open'}>Opens</option>
                        <option value={'click'}>Clicks any link</option>
                </select>
            </div>
            <div className="field-wrap">
                <label className="label-xs"># of times</label>
                <input 
                    type="text" 
                    name="event_count" 
                    value={data.condition.event_count} 
                    onChange={data.handleLeadsFieldChange(data.index)}
                    onBlur={onBlur(data.index)}
                    onFocus={onFocus(data.index)}
                    />
                    {(data.errors[(data.index)]).hasOwnProperty('message') ? <span className="validation-error">{data.errors[data.index].message}</span> :''}
            </div>
            {data.index !== 0 && <div className="box-btn">
                <span onClick={()=>{
                    data.removeLeadCondition(data.index);
                }}><i className='bx bxs-trash-alt'></i></span>
            </div>}
        </div>
        
        </div>
    </>);
}
export default LeadCondition;